
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../directives/directives.module';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SubHeaderModule } from '../components/common/sub-header/sub-header.module';
// import { HelpModule } from '../components/common/help/help.module';
import { ActionsProcessComponent } from './actions.process.component';
import { FormPlycaModule } from '../components/forms/formPlyca.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DialogModule } from 'primeng-lts/dialog';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { TableModule } from 'primeng-lts/table';
import { TooltipModule } from 'primeng-lts/tooltip';



@NgModule({
  declarations: [ActionsProcessComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    DynamicDialogModule,
    DirectivesModule,
    WaitLoadingModule,
    A11yModule,
    FormPlycaModule,
    SubHeaderModule,
    ScrollPanelModule,
    DialogModule,
    ProgressBarModule,
    TableModule,
    TooltipModule
  ]


  // IMPORTANT:
  // Since 'AdditionCalculateWindow' is never explicitly used (in a template)
  // we must tell angular about it.
  // entryComponents: [ AdditionCalculateWindow ]
})
export class ActionsProcessModule { }
